//packages
import React, { useState } from 'react'
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'

//custom components
import { CrossIcon } from 'components/Icons'
import NotificationExitModal from './NotificationExitModal'

//assets
import { Helmet } from 'react-helmet'

export default function AuthLayout() {
  const HomeLogo = "https://remote-recruit-email-temp.s3.us-east-1.amazonaws.com/website_images/SquarewhiteRR300.webp"
  const [showModal, setShowModal] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const { role } = location.state ? location.state : ''
  const pathName = location.pathname ? location.pathname : ''

  const back = () => {
    let show_signup_notification = localStorage.getItem(
      'show_signup_notification'
    )
    if (show_signup_notification !== null) {
      if (show_signup_notification === 'true') {
        setShowModal(true)
      } else {
        navigate('/')
      }
    } else {
      navigate('/')
    }
  }

  return (
    <div className="min-h-screen w-full relative overflow-hidden" style={{
      background: "linear-gradient(131.34deg, #00113C 6.63%, #1E3E85 102.45%)"
    }}>
      <div className="w-[350px] h-[350px] bg-white rounded-full absolute top-[-200px] left-[90px] opacity-[0.02]" />
      <div className="w-[350px] h-[350px] bg-white rounded-full absolute bottom-[-100px] right-[90px] opacity-[0.02]" />
      <Helmet>
        <title>Access Remote Recruit - Remoterecruit.com</title>
        <meta
          name="description"
          content="Securely log in or register to connect with global remote job opportunities."
        />
      </Helmet>
      <Link
        to="/"
        className="absolute top-[20px] md:top-10 left-[0px] md:left-10"
      >
        <img className="w-[100px] md:w-[130px] h-[100px] md:h-[130px]" src={HomeLogo} alt="home-logo" aria-label="home-logo" loading="lazy" />
      </Link>

      <div className="flex w-full min-h-screen justify-center items-center overflow-y-auto">
        <Outlet />
      </div>

      {
        showModal && (
          <NotificationExitModal
            isOpen={showModal}
            closeModal={() => setShowModal(false)}
            callback={() => navigate('/')}
          />
        )
      }
    </div >
  )
}
